import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "./config";

/**
 * One document per auth user; updated by backend webhooks / Admin SDK only.
 *
 * Firestore rules (merge into your deployed rules; do not let clients write):
 *
 *   match /userSubscriptions/{userId} {
 *     allow read: if request.auth != null && request.auth.uid == userId;
 *     allow write: if false;
 *   }
 */
export const USER_SUBSCRIPTIONS_COLLECTION = "userSubscriptions";

/**
 * @param {string} userId
 * @returns {Promise<Record<string, unknown>|null>}
 */
export async function getUserSubscriptionData(userId) {
  if (!userId) return null;
  try {
    const snap = await getDoc(doc(db, USER_SUBSCRIPTIONS_COLLECTION, userId));
    if (!snap.exists()) return null;
    return snap.data() || null;
  } catch (e) {
    console.warn("getUserSubscriptionData:", e?.message || e);
    return null;
  }
}

/**
 * @param {string} userId
 * @param {(raw: Record<string, unknown>|null) => void} onData
 * @returns {() => void}
 */
export function subscribeUserSubscription(userId, onData) {
  if (!userId) {
    onData(null);
    return () => {};
  }
  const ref = doc(db, USER_SUBSCRIPTIONS_COLLECTION, userId);
  return onSnapshot(
    ref,
    (snap) => {
      onData(snap.exists() ? snap.data() || null : null);
    },
    (err) => {
      console.warn("subscribeUserSubscription:", err?.message || err);
      onData(null);
    }
  );
}
